import { useRef, useState } from 'react';
import { IMessages } from '../index';

export const useFeedbackCollector = () => {
    const [isCollectingFeedbackReason, setIsCollectingFeedbackReason] = useState(false);
    const feedbackMessageRef = useRef<IMessages | null>(null);

    return {
        isCollectingFeedbackReason,
        setIsCollectingFeedbackReason,
        feedbackMessageRef,
    };
};
